import request from './request';

/**
 * 测试用例API - V2
 */

// 从执行记录创建测试用例
export function createTestCaseFromExecutionLog(executionLogId, data) {
  return request({
    url: `/eval/test-cases/from-execution-log/${executionLogId}`,
    method: 'post',
    data
  });
}

// 从整条执行计划创建测试用例
export function createTestCaseFromPlan(planId, data) {
  return request({
    url: `/eval/test-cases/from-plan/${planId}`,
    method: 'post',
    data
  });
}

// 手动创建测试用例
export function createTestCase(data) {
  return request({
    url: '/eval/test-cases',
    method: 'post',
    data
  });
}

// 批量导入测试用例
export function batchImportTestCases(data) {
  return request({
    url: '/eval/test-cases/batch-import',
    method: 'post',
    data
  });
}

// 获取测试用例列表
export function getTestCases(params) {
  return request({
    url: '/eval/test-cases',
    method: 'get',
    params
  });
}

// 搜索执行记录（用于创建测试用例时选择）
export function searchExecutionLogs(keyword, limit = 10, id = null) {
  const params = { keyword, limit };
  if (id) params.id = id;
  return request({
    url: '/eval/test-cases/search-execution-logs',
    method: 'get',
    params
  });
}

// 获取测试用例统计
export function getTestCaseStatistics() {
  return request({
    url: '/eval/test-cases/statistics',
    method: 'get'
  });
}

// 获取测试用例详情
export function getTestCaseDetail(id) {
  return request({
    url: `/eval/test-cases/${id}`,
    method: 'get'
  });
}

// 更新测试用例
export function updateTestCase(id, data) {
  return request({
    url: `/eval/test-cases/${id}`,
    method: 'put',
    data
  });
}

// 删除测试用例
export function deleteTestCase(id) {
  return request({
    url: `/eval/test-cases/${id}`,
    method: 'delete'
  });
}

// 获取测试用例的快照列表
export function getTestCaseSnapshots(testCaseId) {
  return request({
    url: `/eval/snapshots/test-case/${testCaseId}`,
    method: 'get'
  });
}

